"use client";

import { type Dispatch, type ReactNode, type SetStateAction, createContext } from "react";
import { ThemeProvider, useTheme } from "next-themes";
import { Toaster } from "sonner";
import useLocalStorage from "@/hooks/use-local-storage";

export const AppContext = createContext<{
	font: string;
	setFont: (font: string) => void;
}>({
	font: "Default",
	setFont: () => { },
});

const ToasterProvider = () => {
	const { theme } = useTheme() as {
		theme: "light" | "dark" | "system";
	};
	return <Toaster theme={theme} />;
};

export default function Providers({ children }: { children: ReactNode }) {
	const [font, setFont] = useLocalStorage<string>("novel__font", "Default");

	return (
		<ThemeProvider attribute="class" enableSystem disableTransitionOnChange defaultTheme="light">
			<AppContext.Provider
				value={{
					font,
					setFont,
				}}
			>
				<ToasterProvider />
				{children}
			</AppContext.Provider>
		</ThemeProvider>
	);
}
